const ServiceRoutes = {
  CreateCompagny: "/lease/request/compagny-info",
  TestDemande: "/lease/request/test-eligibility",
  SendFile: "/lease/request/financial-statement",
  CreateAssistance: '/lease/request/assistance',

};

export default ServiceRoutes;
